import { AdvancedFilterValue, DateFilterOption } from '@access-erp/ui-components';

// Build a reverse map from DateFilterOption display values to their enum keys.
// DateFilterOption maps keys (e.g. "LastXMonths") to display values (e.g. "Last X months").
// The backend's DateFilterTypes enum expects PascalCase keys (e.g. "LastXMonths"),
// so we need to convert display values back to keys before sending to GraphQL.
const dateFilterDisplayToKey = Object.entries(DateFilterOption).reduce(
  (map, [key, displayValue]) => {
    map[displayValue] = key;
    return map;
  },
  {} as Record<string, string>,
);

const replaceTypeOnAdvancedFilter = (filter: AdvancedFilterValue) => {
  if (filter.value && typeof filter.value === 'object' && 'advanced' in filter.value) {
    const advanced = filter.value.advanced as { type: string };
    const filterValueType = advanced.type;
    // Convert display value (e.g. "Last X months") to enum key (e.g. "LastXMonths")
    // Also handle cases where the type is already a valid key (passthrough via fallback)
    advanced.type = dateFilterDisplayToKey[filterValueType] ?? filterValueType;
  }
  return filter;
};

export const replaceAdvancedValueType = (savedFilters: AdvancedFilterValue[]) => {
  savedFilters.forEach((advFilter) => replaceTypeOnAdvancedFilter(advFilter));
  return savedFilters;
};

export const mergeAdvancedFilters = (
  defaultFilters: AdvancedFilterValue[],
  savedFilters: AdvancedFilterValue[],
): AdvancedFilterValue[] => {
  const tempMap = new Map<string, AdvancedFilterValue>();

  [...defaultFilters, ...savedFilters].forEach((advFilter) => {
    tempMap.set(advFilter.name, replaceTypeOnAdvancedFilter(advFilter));
  });

  return Array.from(tempMap.values());
};
